<template>
  <div
      id="generalOption"
      class="generalOption setting_wrap"
      style="scroll-behavior: smooth;"
  >
    <Options
        id="sectionOptions"
        :langProps="lang"
        :unitProps="unit"
        :noticeProps="notice"
        @changeLanguage="changeLanguage"
        @changeUnits="changeUnits"
    />
    <MyProfile id="sectionProfile"/>
    <!--    TODO: 운영 반영시 제거-->
    <PaymentSetting
        v-if="!live"
        id="sectionPayment"
    />
    <ChangePw id="sectionChangePw"/>
    <CookieSetting id="sectionCookie"/>
    <DeleteAccount id="sectionAccount"/>
  </div>
</template>
<script>
import Options from './options';
import MyProfile from './myProfile';
import PaymentSetting from './paymentSetting';
import ChangePw from './changePw';
import DeleteAccount from './deleteAccount';
import CookieSetting from './cookieSetting';
import {mapActions} from "vuex";
import _API from "../../../../api";

export default {
  name: 'GeneralOption',
  components: {
    Options,
    MyProfile,
    PaymentSetting,
    ChangePw,
    DeleteAccount,
    CookieSetting
  },
  data() {
    return {
      window: window,
      lang: {value: ''},
      unit: {value: ''},
      notice: {value: ''},
      // TODO: 운영 반영시 제거
      live: process.env.VUE_APP_MODE === 'LIVE',
    }
  },
  methods: {
    ...mapActions(['changeUnitToVueX']),
    getCurrentLanguage() {
      const curr = localStorage.getItem('lang');
      if (curr) {
        return curr
      } else {
        return null;
      }
    },
    setLanguage() {
      const language = this.getCurrentLanguage();
      if (!language && typeof language === "object") {
        localStorage.setItem("lang", 'en');
        this.lang.value = 'en';
      } else {
        this.lang.value = language;
      }
    },
    setUnits() {
      const unit = localStorage.getItem('unit');
      if (!unit && typeof unit === "object") {
        localStorage.setItem("unit", 'metric');
        this.changeUnitToVueX(unit);
        this.unit.value = 'metric';
      } else {
        this.unit.value = unit;
        this.changeUnitToVueX(unit);
      }
    },
    setNotice() {
      // 알림 설정 값이 default 인 경우 만 질문함
      if (this.$fbConf.isSupported) {
        Notification.requestPermission()
            .then((permission) => {
              if (permission === "granted") {
                this.notice.value = permission;
                this.$fbConf.GET_FCM_TOKEN()
                    .then(newToken => {
                      const oldToken = localStorage.getItem('fcmToken');
                      if (oldToken !== newToken) {
                        this.updateFcmToken(newToken);
                      }
                    })
              } else {
                localStorage.setItem('fcmToken', '');
                this.notice.value = "denied";
              }
            });
      } else {
        this.notice.value = "notSupported";
      }
    },
    changeLanguage(lang) {
      localStorage.setItem('lang', lang);
      this.lang.value = lang;
      this.$i18n.locale = lang;
    },
    changeUnits(unit) {
      localStorage.setItem('unit', unit);
      this.changeUnitToVueX(unit);
    },
    updateFcmToken(token) {
      return new Promise((resolve) => {
        _API.USER.updateFcmToken(token)
            .then(({data}) => {
              if (data.isSuccess) {
                localStorage.setItem('fcmToken', token);
              }
              resolve();
            })
      });
    }
  },
  mounted() {
    this.setLanguage();
    this.setUnits();
    this.setNotice();
  }
}
</script>
<style lang="scss">
.setting_wrap {
  overflow-y: auto;
  height: calc(var(--app-height) - 93px);
  text-align: initial;
}

.set_language {
  overflow: hidden;
  margin-top: 40px;

  li {
    width: 120px;
    display: inline-block;
    margin-right: 10px;
  }
}

.set_form {
  width: 500px;
  margin-top: 30px;

  li {
    position: relative;
    padding: 25px 0 40px 0;

    label {
      position: relative;
      width: 100%;

      input {
        -webkit-appearance: none;
        width: 100%;
        height: 40px;
        border: 1px solid var(--grey20);
        font-size: 16px;
        background: #ffffff;
        border-radius: 4px;
        color: var(--blue70);
        -webkit-transition: all 0.15s ease;
        transition: all 0.15s ease;
        text-indent: 20px;
      }

      .label {
        position: absolute;
        top: -45px;
        left: 0px;
        font-size: 13px;
        color: var(--grey70);
        font-weight: 700;
        width: 250px;
      }
    }
  }
}

.set_my_photo {
  margin-left: 80px;
  flex: 5;
  overflow: hidden;

  .set_photo_area {
    width: 340px;
    height: 222px;
    position: relative;
    overflow: hidden;
    margin-right: 20px;
    border-radius: 5px;
    background: #c8c8c8;
    float: left;

    .set_photo_frame {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      -webkit-transform: translate(50%, 50%);
      -ms-transform: translate(50%, 50%);
      transform: translate(50%, 50%);

      img {
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        min-height: 100%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
    }
  }

  .set_photo_btn {
    float: left;
    width: 200px;
    margin-top: 120px;

    li {
      margin-top: 20px;
    }
  }
}

.option_desc {
  color: var(--grey90);
  font-weight: 700;
}

</style>